import { render, staticRenderFns } from "./search-recipes.vue?vue&type=template&id=7549133e&scoped=true&"
import script from "./search-recipes.vue?vue&type=script&lang=js&"
export * from "./search-recipes.vue?vue&type=script&lang=js&"
import style0 from "./search-recipes.vue?vue&type=style&index=0&id=7549133e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7549133e",
  null
  
)

export default component.exports